module.exports = __webpack_public_path__ + "img/mylogo.10f5a376.png";